import React, { useEffect, useState } from 'react'
import InnerLayout from "../../../../../../layouts/internalLayout"
import { Oval } from 'react-loader-spinner'
import { useMessage } from '../../../../../../context/messageContext'
import { addNewRightItem, deleteSysFrameSashInUsed, getAllPrintTemplate, getAllSashProductAccessories, getItemDetails, getTabPrintTemplate, updateItemDetails } from '../../../../../../services/sysSashProductsService'
import { useRightContext } from '../../../../../../context/rightMenuContext'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { sashProductsSidebarMenu } from '../../../../../../utility/data'
import SashProductsLeft from './left'
import SashProductsRight from './right'
import { getSysFrameSashInUsed, removePanelProdInUsed } from '../../../../../../services/commonServices'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import { MdKeyboardArrowDown } from 'react-icons/md'
import NoDataCard from '../../../../../../components/NoDataCard'
import { handleError } from '../../../../../../utility/commonHelper'
import { getSashProductsCollection } from '../../../../../../services/sysSashCollectionService'

const SashProducts = () => {

    const accessToken = localStorage.getItem('access_token')

    const [pageName, setPageName] = useState("Casement sash")

    const [activeTab, setActiveTab] = useState("General")
    const [printIdKey, setPrintIdKey] = useState('')

    const [loading, setLoading] = useState(true)
    const [selectItemDetails, setSelectItemDetails] = useState([])
    const [allRightListItems, setAllRightListItems] = useState([])
    const [usedProducts, setUsedProducts] = useState([])
    const [allSashProductAccessories, SetAllSashProductAccessories] = useState([])
    const { setMessage, setMessageType } = useMessage()
    const { timestamp, setSelectedRightItem, fetchSelected, toDelete, setTimestamp, activeIndex, setActiveIndex, setMainMenuActive, setSubMenuActive, setSubMenu2Active } = useRightContext()


    const [headerDropdown, setHeaderDropdown] = useState(false);
    const [mainDropdownList, setMainDropdownList] = useState([])
    const [frameCollection, setFrameCollection] = useState('')
    const [sashMasterId,setSashMasterId]=useState(null)

    const navigate = useNavigate();

    var getFirstElId = allRightListItems[0]?.id || ''
    var itemAddedTrue = ''

    const location = useLocation();
    const sashId = location.state ? location.state.data : null

    // let { sashId } = useParams();

    useEffect(() => {
        getAllSashService()
        
        setMainMenuActive("Products")
        setSubMenuActive("Systems")
        setSubMenu2Active("")
    }, [])

    useEffect(() => {
        if (mainDropdownList && mainDropdownList.length > 0) {
            console.log(location, "sashId",mainDropdownList)

            if (sashId) {
                const collectionItem = mainDropdownList?.find((p) => p.id == sashId)

                if (collectionItem && collectionItem.id) {
                    setFrameCollection(collectionItem)
                    // setSashMasterId(collectionItem?.typeId)
                }
            } else {
                setFrameCollection(mainDropdownList[0])
                // setSashMasterId(mainDropdownList[0]?.typeId)
            }
        } else {
            setLoading(false)
        }
    }, [mainDropdownList]);

    // This is for selecting the master sash id from the collection
    useEffect(() => {
      if (mainDropdownList && mainDropdownList?.length > 0) {
        let item = mainDropdownList?.find(
          (item) => item?.id === selectItemDetails?.sashProductMasterId
        );
        if (item) {
          setSashMasterId(item?.typeId);
        } else {
          setSashMasterId(mainDropdownList[0]?.typeId);
        }
      }
    }, [selectItemDetails?.sashProductMasterId]);

    useEffect(() => {
        if (frameCollection?.id && timestamp) {
            getSysFrameSashInUsedService()
        };
    }, [frameCollection?.id, timestamp, activeTab, toDelete?.id]);

    useEffect(() => {
        setLoading(true)
        setActiveTab("General")
        setTimestamp('')
        setActiveIndex(0)

        setTimeout(() => {
            const getPageName = sashProductsSidebarMenu.filter((item) => {
                return item.id == frameCollection?.id;
            });

            setPageName(getPageName[0]?.name)

            if (frameCollection?.id) {
                getAllPrintTempData(frameCollection?.id)
            }
        }, 400);
    }, [frameCollection?.id])

    useEffect(() => {
        if (activeTab !== "Sash hanging") {
            setPrintIdKey(timestamp)
        }

        if (activeTab !== "Accessories" && activeTab !== "Sash hanging") {
            if (allRightListItems?.length > 0 && timestamp) {
                getRightItemDetails(timestamp, activeTab)
            }
        }

        if (activeTab === "Accessories") {
            getAllSashProductAccessoriesServices(timestamp)
        }
        if (timestamp && allRightListItems.length > 0) {
            const selectedRight = allRightListItems?.find((p) => p.id == timestamp)
            setSelectedRightItem(selectedRight)
        }
    }, [timestamp])

    useEffect(() => {
        if (getFirstElId && allRightListItems?.length > 0 && activeIndex !== -1) {
            if (allRightListItems?.length > 0 && activeIndex !== 0 && timestamp) {
                getRightItemDetails(timestamp, activeTab)
            } else {
                getRightItemDetails(getFirstElId, activeTab)
            }
        } else {
            setSelectItemDetails([])
        }
    }, [allRightListItems])

    useEffect(() => {
        if (activeTab !== "Accessories" && activeTab !== "Sash hanging") {
            if (timestamp) {
                if (timestamp && activeTab !== "General") {
                    getTabAllPrintTempData()
                } else {
                    getRightItemDetails(timestamp, activeTab)
                }
            } else {
                setSelectItemDetails([])
            }
        }

        if (activeTab === "Accessories") {
            getAllSashProductAccessoriesServices(timestamp)
        }
    }, [activeTab])

    const getAllSashService = async () => {

        const res = await getSashProductsCollection(accessToken);

        if (res && res && res.status === 200) {
            if (res?.data?.statusCode === 200) {
                if (res?.data?.entity !== null) {
                    setMainDropdownList(res?.data?.entity)
                } else {
                    setLoading(false)
                    setMainDropdownList([])
                }
            }
        }
    }

    const toggleTabDropdown = () => setHeaderDropdown((prevState) => !prevState);


    // get all right item lists
    const getAllPrintTempData = async (fetchId) => {
        const res = await getAllPrintTemplate(accessToken, fetchId);

        if (res && res && res.status === 200) {

            if (res?.data?.statusCode === 200) {
                if (res?.data?.entity !== null) {

                    if (res?.data?.entity?.length > 0) {
                        setAllRightListItems(res?.data?.entity)

                        console.log(itemAddedTrue, "itemAddedTrue")

                        if (itemAddedTrue == 'added') {
                            const addedItemIndex = res.data.entity.length - 1

                            if (addedItemIndex) {
                                fetchSelected(addedItemIndex, res.data.entity[addedItemIndex]?.id)
                                itemAddedTrue = ''
                            }
                        }

                    } else {
                        setAllRightListItems([])
                        setTimestamp('')

                        fetchSelected(0, '');
                    }
                }

                setTimeout(() => {
                    setLoading(false)
                }, 1200);
            } else {
                setLoading(false)
                setMessage(res?.data.message ? res.data.message : 'Something went wrong');
                setMessageType('error')
            }

        } else {
            setLoading(false)
            setMessage(res?.message ? res.message : 'Something went wrong');
            setMessageType('error')

            handleError(res, false, navigate)
        }
    }

    // get selected item details
    const getTabAllPrintTempData = async () => {
        setLoading(true)

        const res = await getTabPrintTemplate(accessToken, printIdKey, activeTab);

        // console.log(res?.data?.entity, "tab data details")

        if (res && res && res.status === 200) {

            if (res?.data?.statusCode === 200) {
                if (res?.data?.entity !== null) {
                    setSelectItemDetails(res?.data?.entity)
                } else {
                    setSelectItemDetails([])
                }

                setTimeout(() => {
                    setLoading(false)
                }, 1200);
            } else {
                setLoading(false)
                setMessage(res?.data.message ? res.data.message : 'Something went wrong');
                setMessageType('error')
            }

        } else {
            setLoading(false)
            setMessage(res?.message ? res.message : 'Something went wrong');
            setMessageType('error')

            handleError(res, false, navigate)
        }
    }

    // get details of selected item in right menu by passing item id
    const getRightItemDetails = async (id, tabName) => {
        setLoading(true);

        const res = await getItemDetails(accessToken, id, tabName);

        if (res && res && res.status === 200) {

            if (res?.data?.statusCode === 200) {

                if (res?.data?.entity !== null) {

                    const selectedRight = allRightListItems?.find((p) => p.id == id)
                    setSelectedRightItem(selectedRight)

                    // set state to get details of current selected item which will display data in left side component
                    setSelectItemDetails(res.data.entity)

                    // set selected item id which will update context
                    setTimestamp(id)
                } else {
                    setSelectItemDetails([])
                }

                setTimeout(() => {
                    setLoading(false)
                }, 1200);
            } else {
                setLoading(false)
                setMessage(res?.data.message ? res.data.message : 'Something went wrong');
                setMessageType('error')
            }

        } else {
            setLoading(false)
            setMessage(res?.message ? res.message : 'Something went wrong');
            setMessageType('error')

            handleError(res, false, navigate)
        }
    }

    // api call to update all selected item details
    const updateItemDetailsServices = async (data, tabType, printID) => {

        setLoading(true)

        const res = await updateItemDetails(accessToken, timestamp ? timestamp : getFirstElId, printID ? printID : printIdKey, data, tabType, frameCollection?.id)

        if (res && res && res.status === 200) {

            if (res?.data?.statusCode === 200) {
                setMessage(res?.data?.message);
                setMessageType('success')

                if (timestamp && activeTab == "Accessories") {
                    getAllSashProductAccessoriesServices(timestamp)
                } else {
                    if (timestamp && activeTab !== "General") {
                        getTabAllPrintTempData()
                    } else if (timestamp && activeTab) {
                        getRightItemDetails(timestamp, activeTab)
                    }
                }

                setTimeout(() => {
                    setLoading(false)
                }, 1200);
            } else {
                setLoading(false)
                setMessage(res?.data?.message ? res.data.message : 'Something went wrong');
                setMessageType('error')
            }
        } else {
            setLoading(false)
            setMessage(res?.message ? res.message : 'Something went wrong');
            setMessageType('error')

            handleError(res, false, navigate)
        }
    }

    // api to add new right item
    const addNewRightItemServices = async (title) => {
        setLoading(true)

        itemAddedTrue = "added"

        setActiveTab("General")

        const res = await addNewRightItem(accessToken, title, frameCollection?.id)

        if (res && res && res.status === 200) {

            if (res?.data?.statusCode === 200) {
                setMessage(res?.data?.message);
                setMessageType('success')

                getAllPrintTempData(frameCollection?.id)

            } else {
                setLoading(false)
                setMessage(res?.data?.message ? res.data.message : 'Something went wrong');
                setMessageType('error')
            }
        } else {
            setLoading(false)
            setMessage(res?.message ? res.message : 'Something went wrong');
            setMessageType('error')

            handleError(res, false, navigate)
        }
    }

    const handleFormReset = () => {
        if (timestamp) {

            if (activeTab === "General") {
                getAllPrintTempData(frameCollection?.id)
            }

            getRightItemDetails(timestamp, activeTab)
        }
    }

    const getSysFrameSashInUsedService = async () => {
        setLoading(true)

        let fetchId = timestamp

        if (toDelete && toDelete?.id) {
            fetchId = toDelete?.id
        }

        const res = await getSysFrameSashInUsed(accessToken, fetchId, frameCollection?.id)

        if (res && res && res.status === 200) {
            if (res?.data?.statusCode === 200) {

                if (res.data.entity.result !== null) {
                    setUsedProducts(res.data.entity.result)
                } else {
                    setUsedProducts([])
                }

                setLoading(false)
            } else {
                setLoading(false)
                setMessage(res?.data?.message ? res.data.message : 'Something went wrong');
                setMessageType('error')
            }
        } else {
            setLoading(false)
            setMessage(res?.message ? res.message : 'Something went wrong');
            setMessageType('error')

            handleError(res, false, navigate)
        }
    }

    const deleteSysFrameSashInUsedService = async (itemId) => {

        const res = await deleteSysFrameSashInUsed(accessToken, itemId, "Profiles")

        if (res && res.status === 200) {
            if (res?.data?.statusCode === 200) {
                setMessage(res?.data?.message ? "Profile unlinked" : 'Profile unlinked');
                setMessageType('success')
                getSysFrameSashInUsedService()

            } else {
                setMessage(res?.data?.message ? res.data.message : 'Something went wrong');
                setMessageType('error')
                getSysFrameSashInUsedService()
            }
        } else {
            setLoading(false)
            setMessage(res?.message ? res.message : 'Something went wrong');
            setMessageType('error')
            
            getSysFrameSashInUsedService()

            handleError(res, false, navigate)
        }
    }

    const getAllSashProductAccessoriesServices = async () => {
        const res = await getAllSashProductAccessories(accessToken, timestamp)

        if (res && res && res.status === 200) {
            if (res?.data?.statusCode === 200) {
                if (res?.data?.entity !== null) {
                    if (res?.data?.entity) {
                        SetAllSashProductAccessories(res?.data?.entity)
                    } else {
                        SetAllSashProductAccessories('')
                    }
                }
            }
        }
    }

    const handleItemSelect = (value) => {
        setFrameCollection(value)
    }
    const removePanelProdInUsedService = async (itemId, productType) => {

        const res = await removePanelProdInUsed(accessToken, itemId, productType)

        if (res && res.status === 200) {
            debugger;
            if (res?.data?.statusCode === 200) {
                setMessage(res?.data?.message ? res?.data?.message : 'Invalid data');
                setMessageType('success')
                getSysFrameSashInUsedService()

            } else {
                setMessage(res?.data?.message ? res.data.message : 'Something went wrong');
                setMessageType('error')
                getSysFrameSashInUsedService()
            }
        } else {
            setLoading(false)
            setMessage(res?.message ? res.message : 'Something went wrong');
            setMessageType('error')
            
            getSysFrameSashInUsedService()

            handleError(res, false, navigate)
        }
    }
    return (
        <>
            {loading && (
                <div className='loader_main full_loader left_loader'>
                    <Oval
                        height={50}
                        width={50}
                        color="#44C8F5"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#44C8F5"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            )}

            {mainDropdownList && mainDropdownList.length > 0 ? (
                <InnerLayout pageTitle={""} layoutType=""
                    leftContent={
                        <>
                            {allRightListItems && allRightListItems.length > 0 ? (
                                <SashProductsLeft navigate={navigate} setMessageType={setMessageType} setMessage={setMessage} allSashProductAccessories={allSashProductAccessories} getAllSashProductAccessoriesServices={getAllSashProductAccessoriesServices} pageName={pageName} sashId={frameCollection?.id} handleFormReset={handleFormReset} accessToken={accessToken} activeTab={activeTab} setActiveTab={setActiveTab} updateItemDetailsServices={updateItemDetailsServices} loading={loading} selectItemDetails={selectItemDetails} setLoading={setLoading} usedInProductsList={usedProducts} deleteSysFrameSashInUsedService={deleteSysFrameSashInUsedService} removePanelProdInUsedService={removePanelProdInUsedService} sashMasterId={sashMasterId} />
                            ) : (
                                <div className='mt-5'>
                                    <NoDataCard text="items" loading={loading} isText={true} />
                                </div>
                            )}
                        </>
                    }
                    rightContent={<SashProductsRight accessToken={accessToken} sashId={frameCollection?.id} selectItemDetails={selectItemDetails} allRightListItems={allRightListItems} setLoading={setLoading} getAllPrintTempData={getAllPrintTempData} addNewRightItemServices={addNewRightItemServices} usedInProductsList={usedProducts} />}
                    rightMaster={true}
                    filterButton={<Dropdown
                        isOpen={headerDropdown}
                        toggle={toggleTabDropdown}
                    >
                        <DropdownToggle color="none" className="border-0 p-0">
                            <div className="d-flex align-items-center">
                                <span className="fw-semibold fs-5">
                                    {frameCollection && frameCollection?.name}
                                    <MdKeyboardArrowDown className="ms-1" size={20} />
                                </span>
                            </div>
                        </DropdownToggle>

                        <DropdownMenu className='full_height'>
                            {mainDropdownList && mainDropdownList?.map((item, index) => {
                                return (
                                    <DropdownItem
                                        onClick={() => handleItemSelect(item)}
                                        key={index}
                                        disabled={item?.id == frameCollection?.id}
                                        className={`${item?.id == frameCollection?.id ? 'text-primary fw-medium' : ''}`}
                                    >
                                        {item?.name}
                                    </DropdownItem>
                                );
                            })}
                        </DropdownMenu>
                    </Dropdown>}
                />
            ) : (
                <NoDataCard text="sash" loading={loading} />
            )}

        </>
    )
}

export default SashProducts